__turbopack_context__.v({
  "CategoryDescription": "_2Bmkoq_CategoryDescription",
  "CategoryHeading": "_2Bmkoq_CategoryHeading",
  "CategoryTitle": "_2Bmkoq_CategoryTitle",
  "ContentWrapper": "_2Bmkoq_ContentWrapper",
  "QtyControl": "_2Bmkoq_QtyControl",
  "TicketNotice": "_2Bmkoq_TicketNotice",
  "Tier": "_2Bmkoq_Tier",
  "TierWrapper": "_2Bmkoq_TierWrapper",
  "TiersWrapper": "_2Bmkoq_TiersWrapper",
});
